const LISTAR_DADOS = (state, payload) => {
  state.items = payload.data || []
  state.paginacao = {
    per_page: payload.per_page || 100,
    current_page: payload.current_page || 1,
    last_page: payload.last_page || 1,
    total: payload.total || 0,
    from: payload.from || 1,
    to: payload.to || 0
  }
}

const CARREGANDO = (state, payload) => {
  state.carregando = payload
}

export {
    LISTAR_DADOS,
    CARREGANDO
}
